import type { RateBasis } from '@chukua/common';
import { RATE_BASIS_LABELS } from '../../../shared/policies/rate-basis-labels';

/** What identifies a price apart from its dates — the same columns the API folds into `rate_lines.line_key`. */
export interface RateLineKeyFields {
  originZoneCode: string;
  destinationZoneCode: string;
  jobTypeCode: string;
  containerSizeCode: string | null;
  containerTypeCode: string | null;
  weightBandCode: string | null;
  basis: RateBasis;
}

/** "40 dry" for a container line, the band's code for loose cargo. */
export function describeCargo(key: Pick<RateLineKeyFields, 'containerSizeCode' | 'containerTypeCode' | 'weightBandCode'>): string {
  if (key.weightBandCode) return key.weightBandCode;
  return [key.containerSizeCode, key.containerTypeCode].filter(Boolean).join(' ');
}

export function laneOf(key: Pick<RateLineKeyFields, 'originZoneCode' | 'destinationZoneCode'>): string {
  return `${key.originZoneCode} → ${key.destinationZoneCode}`;
}

/** Two lines with the same key are versions of one price. */
export function keyOf(key: RateLineKeyFields): string {
  return [key.originZoneCode, key.destinationZoneCode, key.jobTypeCode, key.containerSizeCode, key.containerTypeCode, key.weightBandCode, key.basis].join('|');
}

/** "MSA → NBO · container-fcl · 40 dry · Per container": which price this is, for a drawer's heading. */
export function formatLineKey(key: RateLineKeyFields): string {
  return [laneOf(key), key.jobTypeCode, describeCargo(key), RATE_BASIS_LABELS[key.basis]].join(' · ');
}
